"use client"

import React, { useMemo } from "react"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { CheckoutContext } from "@/lib/storefront/checkout/checkout-service"
import { AddressFields } from "@/components/common/addresses/AddressFields"
import BasicCard from "@/components/common/BasicCard"
import { UbCheckoutReviewInvoiceToAddressesStoryblok } from "@/components/storyblok/component-types"

interface CheckoutReviewAddressesInvoiceToClientProps {
  blok: UbCheckoutReviewInvoiceToAddressesStoryblok
  checkoutContext: CheckoutContext
}

export default function CheckoutReviewAddressesInvoiceToClient(props: CheckoutReviewAddressesInvoiceToClientProps) {
  const { basketData } = useUbStorefrontState()

  const invoiceToAddress: any = useMemo(() => {
    const commonInvoiceToAddressLink = basketData?.data?.invoiceToAddress
    if (commonInvoiceToAddressLink) {
      return basketData?.included?.invoiceToAddress
        ? basketData?.included?.invoiceToAddress[commonInvoiceToAddressLink]
        : undefined
    }
  }, [basketData])

  return (
    <div className={"flex w-full flex-col gap-12"}>
      <BasicCard className={"top-30 min-h-0 border-none p-0 sm:p-0 lg:top-34"}>
        <div className={"flex w-full flex-col justify-between gap-12 sm:flex-row"}>
          <div className={"flex w-full flex-row justify-between gap-2"}>
            <AddressFields address={invoiceToAddress} isB2B={props.checkoutContext.isB2B} />
          </div>
        </div>
      </BasicCard>
    </div>
  )
}
